import p from "./header-navigation-horizontal.vue.js";
import S from "./header-navigation-vertical.vue.js";
import { resolveComponent as u, createElementBlock as h, openBlock as b, createVNode as d, createSlots as s, renderList as l, withCtx as o, renderSlot as m, normalizeProps as c, guardReactiveProps as v } from "vue";
/* empty css                                   */
import g from "../../../_virtual/_plugin-vue_export-helper.js";
import I from "../../../utils/mixins/theme/theme.vue.js";
const N = {
  name: "DsHeaderNavigation",
  components: { DsHeaderNavigationHorizontal: p, DsHeaderNavigationVertical: S },
  mixins: [I],
  inject: ["updateHeaderFreezeTransition"],
  props: {
    /**
     * Screen size based on breakpoints
     */
    screen: { type: String, required: !0 },
    /**
     * Navigation primary items
     */
    primaryItems: {
      type: Array,
      default: () => [],
      validator: (e) => e.every((t) => typeof t == "object" && ["id", "title"].every((i) => i in t))
    },
    /**
     * Navigation secondary items
     */
    secondaryItems: {
      type: Array,
      default: () => [],
      validator: (e) => e.every((t) => typeof t == "object" && ["title", "url", "openInNewWindow", "nuxt"].every((i) => i in t))
    },
    /**
     * Navigation cta item
     */
    ctaItem: {
      type: Object,
      default: null,
      validator: (e) => ["title", "url", "openInNewWindow", "nuxt"].every((t) => t in e)
    },
    /**
     * Navigation labels
     */
    labels: {
      type: Object,
      required: !0,
      validator: (e) => ["ariaLabelNavigation", "ariaLabelOpenNavigation", "ariaLabelCloseNavigation"].every((t) => t in e)
    }
  },
  data: () => ({
    isSlideOverOpened: !1,
    savedScrollPosition: null
  }),
  methods: {
    onSlideOverOpened() {
      this.updateHeaderFreezeTransition(!0), this.screen === "small" && (this.savedScrollPosition = typeof window < "u" ? window.scrollY : 0, document.body.classList.add("body-slide-over-open"));
    },
    onSlideOverClosed() {
      document.body.classList.remove("body-slide-over-open"), this.screen === "small" && typeof window < "u" && window.scrollTo({ left: 0, top: this.savedScrollPosition }), setTimeout(() => {
        this.screen === "small" && (this.savedScrollPosition = null), this.updateHeaderFreezeTransition(!1);
      }, 100);
    }
  }
};
function w(e, t, i, C, H, a) {
  const f = u("DsHeaderNavigationHorizontal"), y = u("DsHeaderNavigationVertical");
  return b(), h("div", null, [
    d(f, {
      screen: "large",
      class: "ds-hidden ds-lg-hidden--false",
      theme: e.theme,
      "primary-items": i.primaryItems,
      "secondary-items": i.secondaryItems,
      "cta-item": i.ctaItem,
      labels: i.labels,
      onSlideOverOpened: a.onSlideOverOpened,
      onSlideOverClosed: a.onSlideOverClosed
    }, s({ _: 2 }, [
      l(e.$slots, (O, r) => ({
        name: r,
        fn: o((n) => [
          m(e.$slots, r, c(v(n)))
        ])
      }))
    ]), 1032, ["theme", "primary-items", "secondary-items", "cta-item", "labels", "onSlideOverOpened", "onSlideOverClosed"]),
    d(y, {
      screen: "medium",
      class: "ds-hidden ds-md-hidden--false ds-lg-hidden",
      theme: e.theme,
      "primary-items": i.primaryItems,
      "secondary-items": i.secondaryItems,
      "cta-item": i.ctaItem,
      labels: i.labels,
      onSlideOverOpened: a.onSlideOverOpened,
      onSlideOverClosed: a.onSlideOverClosed
    }, s({ _: 2 }, [
      l(e.$slots, (O, r) => ({
        name: r,
        fn: o((n) => [
          m(e.$slots, r, c(v(n)))
        ])
      }))
    ]), 1032, ["theme", "primary-items", "secondary-items", "cta-item", "labels", "onSlideOverOpened", "onSlideOverClosed"]),
    d(y, {
      screen: "small",
      class: "ds-md-hidden",
      theme: e.theme,
      "primary-items": i.primaryItems,
      "secondary-items": i.secondaryItems,
      "cta-item": i.ctaItem,
      labels: i.labels,
      onSlideOverOpened: a.onSlideOverOpened,
      onSlideOverClosed: a.onSlideOverClosed
    }, s({ _: 2 }, [
      l(e.$slots, (O, r) => ({
        name: r,
        fn: o((n) => [
          m(e.$slots, r, c(v(n)))
        ])
      }))
    ]), 1032, ["theme", "primary-items", "secondary-items", "cta-item", "labels", "onSlideOverOpened", "onSlideOverClosed"])
  ]);
}
const T = /* @__PURE__ */ g(N, [["render", w]]);
export {
  T as default
};
